import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as Text from '../../../common/i18n/Text.ts';
import { isDefined, isUndefined, Maybe } from 'dg-web-shared/lib/MaybeV2.ts';
import { SingleSelection } from '../../../ui/labeled-elements/SingleSelection.tsx';
import { permitFilterTexts } from '../../i18n/FilteredClearancesTexts.ts';
import * as PermitTypeState from '../../../common/state/PermitTypeState.ts';
import { StringSingleSelectionSlideIn } from '../../../ui/slidein/SingleSelectionSlideIn.tsx';
import * as FilteredClearancesState from '../../state/FilteredClearancesState.ts';
import {
    clearPermits,
    setPermits,
} from '../../actions/FilteredClearancesActions.ts';

export interface PermitFilterTexts {
    filterTitle: Text.Translation;
    withPermits: Text.Translation;
    withoutPermits: Text.Translation;
}

export function PermitFilterHalfSlideIn() {
    const { storeState, update } = useStore(store => ({
        filter: FilteredClearancesState.Filter.get(store),
    }));
    const { language } = useLanguage();

    const texts = permitFilterTexts[language];
    return (
        <StringSingleSelectionSlideIn
            open={storeState.filter.permitsSelectionVisible}
            heading={permitFilterTexts[language].filterTitle()}
            selection={storeState.filter.permits}
            options={[
                { id: 'WITH_PERMITS', displayText: texts.withPermits() },
                {
                    id: 'WITHOUT_PERMITS',
                    displayText: texts.withoutPermits(),
                },
            ]}
            onLeftActionClick={() =>
                update(store =>
                    FilteredClearancesState.Filter.stateWrite(store, {
                        permitsSelectionVisible: false,
                    }),
                )
            }
            onSelect={v => update(store => setPermits(store, v))}
        />
    );
}

const permitsString = (
    value: Maybe<string>,
    texts: PermitFilterTexts,
): string => {
    if (isUndefined(value)) {
        return '';
    } else if (value === 'WITH_PERMITS') {
        return texts.withPermits();
    } else if (value === 'WITHOUT_PERMITS') {
        return texts.withoutPermits();
    } else {
        return '';
    }
};

export function PermitFilterSelection() {
    const { storeState, update } = useStore(store => ({
        filter: FilteredClearancesState.Filter.get(store),
        permitTypes: PermitTypeState.get(store),
    }));
    const { language } = useLanguage();

    const texts = permitFilterTexts[language];
    const clear = isDefined(storeState.filter.permits)
        ? () => update(clearPermits)
        : null;

    return (
        <SingleSelection
            label={texts.filterTitle()}
            focused={false}
            selection={permitsString(storeState.filter.permits, texts)}
            onClick={() =>
                update(store =>
                    FilteredClearancesState.Filter.stateWrite(store, {
                        permitsSelectionVisible: true,
                    }),
                )
            }
            onClear={clear}
        />
    );
}
